/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import * as R from 'ramda';
import {compose} from 'ramda';
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faBook, faChevronRight} from '@fortawesome/free-solid-svg-icons'
/**
 * The internal dependencies.
 */
import CloseButton from '../../../components/task/close-button';
import {getCurrentHandbook, getTasksCurrent} from "../../../store/tasks/selectors";
import {Document, Page} from "react-pdf";

const verticallyAligned = `
	display: flex;
	align-items: center;
`;

const Wrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 60%;
	height: calc(100% - 50px);
	background: #fff;
	overflow: scroll;

	&:after {
		content: '';
		position: absolute;
		right: 1px;
		top: 0;
		height: 100%;
		box-shadow: 3px 0px 6px rgba(0,0,0, 0.5);
		width: 1px;
	}
`;

const TitleBar = styled.div`
	${verticallyAligned}
	justify-content: space-between;
	padding: 13px 22px 70px 48px;
`;

const Title = styled.h5`
	${verticallyAligned}
	font-size: 40px;
	font-weight: 700;
	color: #3b3b3b;

	& img {
		margin-right: 12px;
	}
`;

const Close = styled.span`
	${verticallyAligned}
	font-size: 14px;
	font-weight: 400;
	color: #43abf3;
`;

const Flip = styled.span`
	${verticallyAligned}
	font-size: 14px;
	font-weight: 400;
	color: #43abf3;
`;

const FlipButton = styled.button`
	display:flex;
	justify-content: center;
	align-items: center;
	min-width: 113px;
	min-height: 41px;
	color: #43abf3;
	background: #fff;
	padding: 0 18px;
	border: none;

	& img {
		margin-right: 4px;
	}

	& + button {
		margin-right: 1px;
	}
`;

const MessageWrapper = styled.div` 
    ${verticallyAligned}
	justify-content: space-between;
	padding: 12px;

`;


class Handbook extends React.Component {
    constructor() {
        super();

        this.state = {
            numPages: null,
            pageNumber: 1,
        }

    }

    onDocumentLoadSuccess = ({numPages}) => {
        this.setState({numPages});
    };

    flipPdf = () => {
        const {pageNumber, numPages} = this.state
        if (numPages != null && numPages > 0) {
            let nextPage = pageNumber + 1;
            if (nextPage > numPages) nextPage = 1;
            this.setState({pageNumber: nextPage});
        }
    };

    render() {
        const {pageNumber, numPages} = this.state;
        const {close, handbook} = this.props;
        let pdfURL = handbook;

        return (
            <Wrapper>
                <TitleBar>
                    <Title>
                        <FontAwesomeIcon size="1x" icon={faBook}/>

                        <span>&nbsp;Handbuch</span>
                    </Title>

                    <Close>
                        <span>Schließen</span>

                        <CloseButton color="#43abf3" onClick={close}/>
                    </Close>
                </TitleBar>

                {pdfURL !== '' && numPages > 1 && <MessageWrapper>
                    <Flip><FlipButton onClick={this.flipPdf}>
                        <span>Nächste Seite&nbsp;</span>
                        <FontAwesomeIcon size="1x"
                                         icon={faChevronRight}/>
                    </FlipButton>
                    </Flip>
                </MessageWrapper>}

                {pdfURL !== '' && <MessageWrapper>
                    <Document
                        file={'data:application/pdf;base64,' + pdfURL}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                    >
                        <Page pageNumber={pageNumber}/>
                    </Document>
                </MessageWrapper>}

                {pdfURL === '' &&
                <MessageWrapper>
                    <span>Kein Handbuch vorhanden!</span>
                </MessageWrapper>
                }
            </Wrapper>
        );
    }
}

export default connect(
    (state) => ({
        currentTask: getTasksCurrent(state),
        handbook: getCurrentHandbook(state),
    })
)(Handbook);

// export default Help;



// WEBPACK FOOTER //
// ./src/components/task/working/handbook.js